import AttentionImg from "../../assets/attention_is_all_you_need.png";
import DeepseekImg from "../../assets/deepseek_paper.png";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function Papers() {
  return (
    <div>
      <div className="flex flex-col md:flex-row fade-in justify-center gap-6 md:gap-8 mx-auto py-8 px-2 mb-8 md:px-4 max-w-[90%] rounded-lg">
        <a
          target="_blank"
          className="w-full block"
          href="https://arxiv.org/pdf/1706.03762"
          rel="noreferrer"
        >
          <img
            alt="Epic Web Dev Talk"
            className="block mx-auto mb-4 outline outline-1 rounded-lg outline-neutral-700 w-full"
            src={AttentionImg}
          />
        </a>
        <div className="flex flex-col gap-2 md:w-full">
          <h3 className="text-lg w-full">Attention is all you need</h3>
          <p className="text-gray-500 my-2 mx-auto text-justify">
            <span className="text-neutral-200">
              Natural Language processing
            </span>{" "}
            was done with the help of{" "}
            <span className="text-neutral-200">Recurring Neural Networks</span>,
            which processed input sentences sequencially. These had its own
            drawbacks particularly with long input sequences.{" "}
            <span className="text-neutral-200">Attention mechanism</span>
            &nbsp;mitigated this issue by being able to access information
            related to hidden states of any intermediate process. This paper
            took it a step further and ditched RNNs saying if Attention is so
            good at keeping context of the hidden states and inputs, why don't
            we fully rely on it and enjoy the parallelisation and ability to
            handle long text?
          </p>
          <div className="flex flex-col w-full">
            <a
              target="_blank"
              className="text-neutral-400 hover:text-white text-sm transition-all duration-300 py-1 flex items-center gap-2 hover:gap-3"
              href="https://omgate.notion.site/Attention-is-all-we-needed-2002e7e8273780b29946c059f3a084a8"
              rel="noreferrer"
            >
              <ArrowTopRightOnSquareIcon width={16} />
              My notes of the paper
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row fade-in justify-center gap-4 md:gap-8 mx-auto py-8 px-2 md:px-4  max-w-[90%] rounded-lg">
        <a
          target="_blank"
          className="w-full block"
          href="https://arxiv.org/pdf/2501.12948"
          rel="noreferrer"
        >
          <img
            alt="Deepseek Paper"
            className="block object-cover mx-auto w-full mb-4 outline outline-1 rounded-lg outline-neutral-700 "
            src={DeepseekImg}
          />
        </a>
        <div className="flex flex-col gap-2 md:w-[100%]">
          <h3 className="text-lg w-full">
            DeepSeek-R1: Incentivizing Reasoning Capability in LLMs via
            Reinforcement Learning
          </h3>
          <p className="text-gray-500 my-2 mx-auto text-justify">
            Even when LLMs such as Claude and Gemini existed, OpenAI still stood
            tall as the front-runners in the AI race. But that changed
            when&nbsp;<span className="text-neutral-200">Deepseek-R1</span> was
            released brought in an LLM with{" "}
            <span className="text-neutral-200">reasoning capabilities</span>{" "}
            similar to the OpenAI's o1 model with fraction of the cost. The
            paper discussed the techniques they used to develop reasoning into
            foundation model, here they used{" "}
            <span className="text-neutral-200">Deepseek-V3-Base</span>, and
            wether{" "}
            <span className="text-neutral-200">Reinforcement Learning</span> is
            enough to develop good reasoning capabilites. This paper also
            discussed the training steps of Deepseek and a very intresting
            method of <span className="text-neutral-200">distillation</span>,
            where the curated data from the Deepseek-R1 training was used to
            train open-source models to develop reasoning capabilities
          </p>
          <div className="flex flex-col w-full">
            <a
              target="_blank"
              className="text-neutral-400 hover:text-white text-sm transition-all duration-300 py-1 flex items-center gap-2 hover:gap-3"
              href="https://omgate.notion.site/Getting-Deep-in-Deepseek-Paper-2002e7e8273780fd8969fbee9a13b0c9"
              rel="noreferrer"
            >
              <ArrowTopRightOnSquareIcon width={16} />
              My notes of the paper
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
